import { Phone, Mail, CloudUpload } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const PHOTOS = {
  toini: "/assets/toini.jpg",
  mikael: "/assets/mikael.jpg",
  dameh: "/assets/dameh.jpg",
  helena: "/assets/helena.jpg",
};

export const Team = ({ t }) => (
  <section id="team" data-testid="team-section" className="relative py-24 lg:py-32 bg-[#F1F2F4] overflow-hidden">
    <div className="absolute -top-32 right-1/4 w-[420px] h-[420px] rounded-full bg-[#C5A059]/15 blur-[130px]" />
    <div className="relative max-w-7xl mx-auto px-6 sm:px-10">
      <Reveal className="max-w-3xl">
        <SectionLabel testid="team-label">{t.team.label}</SectionLabel>
        <h2 data-testid="team-title" className="font-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#0B132B] leading-[1.05] mb-16">
          {t.team.title}
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-6 mb-6">
        {t.team.people.map((p, i) => (
          <Reveal key={p.key} delay={i * 0.1} className="h-full">
            <div
              data-testid={`team-member-${p.key}`}
              className="group h-full p-6 lg:p-8 bg-white border border-[#0B132B]/10 hover:border-[#C5A059]/70 hover:shadow-lg transition-all duration-300"
            >
              <img
                src={PHOTOS[p.key]}
                alt={p.name}
                data-testid={`team-photo-${p.key}`}
                className="w-full aspect-[4/5] object-cover rounded-lg mb-6"
              />
              <h3 className="font-display text-3xl lg:text-4xl font-medium text-[#0B132B]">{p.name}</h3>
              <p className="mt-2 font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#8C713A]">{p.role}</p>
              <p className="mt-5 text-sm text-slate-500 font-light leading-relaxed max-w-md">{p.desc}</p>
              <div className="mt-8 space-y-3">
                {p.phone && (
                  <a
                    data-testid={`team-phone-${p.key}`}
                    href={`tel:${p.phone.replace(/\s/g, "")}`}
                    className="flex items-center gap-3 text-slate-700 hover:text-[#8C713A] transition-colors"
                  >
                    <Phone size={16} className="text-[#C5A059]" />
                    <span className="font-light tracking-wide">{p.phone}</span>
                  </a>
                )}
                <a
                  data-testid={`team-email-${p.key}`}
                  href={`mailto:${p.email}`}
                  className="flex items-center gap-3 text-slate-700 hover:text-[#8C713A] transition-colors break-all"
                >
                  <Mail size={16} className="text-[#C5A059] shrink-0" />
                  <span className="font-light tracking-wide">{p.email}</span>
                </a>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div
          data-testid="fennoa-card"
          className="relative p-8 lg:p-10 border border-[#C5A059]/60 bg-gradient-to-br from-white to-[#FAF7F0] flex flex-col lg:flex-row lg:items-center gap-8 shadow-sm"
        >
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-[#C5A059]/60 text-[#8C713A]">
            <CloudUpload size={24} strokeWidth={1.5} />
          </div>
          <div className="flex-1">
            <h3 data-testid="fennoa-title" className="font-display text-2xl lg:text-3xl font-medium text-[#0B132B]">{t.team.fennoaTitle}</h3>
            <p className="mt-3 text-sm sm:text-base text-slate-500 font-light leading-relaxed max-w-2xl">{t.team.fennoaDesc}</p>
          </div>
          <a
            data-testid="fennoa-cta"
            href="mailto:mikael.knif@dktaccounting.fi"
            className="self-start lg:self-center inline-flex items-center gap-3 rounded-full border border-[#8C713A]/40 text-[#8C713A] px-6 py-3 text-sm hover:bg-[#C5A059]/15 transition-colors whitespace-nowrap"
          >
            <Mail size={15} /> {t.team.fennoaCta}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
